import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_KB_CONFLUENCE_CONTEXT = 'KB_CONFLUENCE_CONTEXT';
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const kbConfluenceContextResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_KB_CONFLUENCE_CONTEXT,
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-kb-confluence-context", jiraSpaEntry: "async-resource-kb-confluence-context" */ './getData.tsx'
		),
	maxAge: Infinity,
});
